export const ACTIVATE_LAYER_OBSTACLES = 'ACTIVATE_LAYER_OBSTACLES';
export const DEACTIVATE_LAYER_OBSTACLES = 'DEACTIVATE_LAYER_OBSTACLES';
export const SET_OBSTACLES_LIST = 'SET_OBSTACLES_LIST';
export const activateObstacleLayer = () => {
  return {
    type: ACTIVATE_LAYER_OBSTACLES,
  };
};

export const deactivateObstacleLayer = () => {
  return {
    type: DEACTIVATE_LAYER_OBSTACLES
  };
};

export const setObstaclesList = (data) => {
  return {
    type: SET_OBSTACLES_LIST,
    payload: data
  };
};